/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as f } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import { Form as l } from "@nubeteck/components";
import { b as p, g as d } from "../../chunks/index.esm.eyITaPoj.js";
import { useFormeckConfig as F } from "../../contexts/formeck-config/formeck-config.js";
import "../../contexts/stepper/stepper.js";
const g = (r, t) => {
  if (r)
    return "error";
  if (t && !r)
    return "success";
}, h = ({ help: r, name: t, children: s, ...m }) => {
  const { intlErrorFn: o } = F(), { errors: a, touchedFields: n } = p(), i = !!o && typeof o == "function", e = a[t]?.message, c = !!d(n, t), u = g(!!e, c);
  return /* @__PURE__ */ f.jsx(
    l.Item,
    {
      hasFeedback: !0,
      style: { flex: 1 },
      validateTrigger: "onBlur",
      validateStatus: u,
      help: e ? i ? o(`${e}`) : `${e}` : r,
      ...m,
      children: s
    }
  );
};
h.displayName = "FormItem";
export {
  h as default
};
